<mat-sidenav-container autosize class="sidenav-container">
  @if (_authService.hasRoles) {
  <mat-sidenav #sidenav mode="side" position="start" [opened]="true" [ngClass]="{
      'sidebar-collapsed': isSidebarCollapsed,
      'sidebar-expanded': !isSidebarCollapsed
    }">
    <mat-nav-list>
      <div class="sidebar-header flex-center pointer" (click)="toggleSidebar()" tabindex="0">
        <img [ngSrc]="'assets/icon/sparkle.png'" alt="texicon_logo" width="30" height="30" routerLink="/dashboard" />
        <mat-icon class="collapse-icon">
          {{ isSidebarCollapsed ? 'chevron_right' : 'chevron_left' }}
        </mat-icon>
      </div>
      <mat-divider />

      @for (item of SIDENAV_ITEMS; track item.link; let i = $index) {
      @if (isSidebarCollapsed) {
      @if (item.children?.length) {
      <!-- Collapsed state: parent with children uses a menu -->
      <mat-list-item [matMenuTriggerFor]="menu" class="collapsed-menu-trigger"
        [ngClass]="{'active-link': activeParentIndex() === i}">
        <mat-icon class="menu-icon material-symbols-outlined">{{ item.icon }}</mat-icon>
      </mat-list-item>
      <mat-menu #menu="matMenu" class="side-sub-nav">
        @for (child of item.children; track child) {
        <button mat-menu-item [routerLink]="child.link" routerLinkActive="active-link">
          @if (child.icon) {
          <mat-icon class="menu-icon material-symbols-outlined">{{ child.icon }} </mat-icon>
          }
          <span>{{ child.label | translate}} </span>
        </button>
        }
      </mat-menu>
      } @else {
      <!-- Collapsed state: simple item without children -->
      <mat-list-item [routerLink]="item.link" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }"
        [ngClass]="{'active-link': activeParentIndex() === i}">
        <mat-icon class="menu-icon material-symbols-outlined">{{ item.icon }}</mat-icon>
      </mat-list-item>
      }
      } @else {
      @if (item.children?.length) {
      <!-- Expanded state: expandable parent -->
      <mat-list-item class="expandable-list-item" (click)="toggleMenuExpansion(i);"
        [ngClass]="{'active-link': activeParentIndex() === i}">
        <div class="side-item-list">
          <mat-icon class="menu-icon material-symbols-outlined">{{ item.icon }}</mat-icon>
          <p class="base-font-size">{{ item.label | translate }}</p>
          <span class="expander-icon material-symbols-outlined">
            {{ expandedMenus[i] ? 'expand_less' : 'expand_more' }}
          </span>
        </div>
      </mat-list-item>

      @if (expandedMenus[i]) {
      @for (child of item.children; track child) {
      <mat-list-item class="nested-option centered-list-item" [routerLink]="child.link" routerLinkActive="active-link">
        <div class="side-item-list child-row">
          @if (child.icon) {
          <mat-icon class="menu-icon material-symbols-outlined">{{ child.icon }}</mat-icon>
          }
          <p class="base-font-size submenu-text">{{ child.label | translate }}</p>
        </div>
      </mat-list-item>
      }
      }
      } @else {
      <!-- Expanded state: simple item -->
      <mat-list-item [routerLink]="item.link" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }"
        [ngClass]="{'active-link': activeParentIndex() === i}">
        <div class="side-item-list">
          <mat-icon class="menu-icon material-symbols-outlined">{{ item.icon }}</mat-icon>
          <p class="base-font-size">{{ item.label | translate }}</p>
        </div>
      </mat-list-item>
      }
      }

      @if (item.isDivider) {
      <mat-divider />
      }
      }
    </mat-nav-list>
  </mat-sidenav>
  }

  <mat-sidenav-content class="sidenav-content">
    <main class="main-content">
      <router-outlet />
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>